<template>
  <div class="historical-agreement-details-box">
    <div class="details-title"><h2>{{title}}</h2></div>
    <div class="details-content">
      <div v-html="content"></div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import { isEmpty, isMobile } from '@/utilities/tools'

export default {
  name: "HistoricalAgreementList",
  data () {
    return {
      title: "",
      content: ''
    }
  },
  created () {
    const query = this.$router.currentRoute.query;
    if(!isMobile()) {
      window.location.href = `${process.env.VUE_APP_PC_URL}/Rccl.UserCenter/HistoricalAgreementDetails?${query}`;
      return;
    }
    let userAgreementType = "";
    let effectiveDateStr = "";
    let ver = "";
    let id = null;
    if (query && !isEmpty(query.type)) {
      if (isNaN(Number(query.type))) {
        return;
      } else {
        userAgreementType = Number(query.type);
      }
    }
    if (query && !isEmpty(query.dateStr)) {
      effectiveDateStr = query.dateStr
    }
    if (query && !isEmpty(query.ver)) {
      if (isNaN(Number(query.ver))) {
        return;
      } else {
        ver = Number(query.ver);
      }
    }
    if (query && !isEmpty(query.id)) {
      if (isNaN(Number(query.id))) {
        return;
      } else {
        id = Number(query.id);
      }
    }
    this.initPage(userAgreementType, effectiveDateStr, ver, id)
  },
  methods: {
    async initPage(userAgreementType, effectiveDateStr, ver, id) {
      const { success, data, errMsg } = await api.user.getAgreementByParams({
        userAgreementType: userAgreementType,
        effectiveDateStr: effectiveDateStr,
        ver: ver,
        id: id
      })
      if (success && data) {
        // this.title = data.title;
        this.content = data.content;
        this.title = this.GlobalData.userAgreementTitleValues[userAgreementType];
      } else {
        console.log(errMsg)
      }
    }
  }
}
</script>
<style lang="less">
.historical-agreement-details-box {
  width: 100%;
  margin: 0 auto;
  & .details-title {
    text-align: center;
    width: 100%;
    background: #f0f0f0;
    & > h2 {
      line-height: 2.2rem;
    }
  }
  & .details-content {
    font-size: 0.75rem;
    position: absolute;
    top: 2.2rem;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 0.75rem;
    background: white;
    overflow-x: hidden;
    overflow-y: auto;
    p {
      margin: 10px 0;
    }
    .table {
      width: 100%;
      overflow-x: auto;
      border-collapse: collapse;
      border: 1px solid #ddd;
    }
    .table .th {
      padding: 8px;
      border: 1px solid #ddd;
    }
    .table .td {
      vertical-align: top;
      padding: 8px;
      border: 1px solid #ddd;
    }
    .table .th p,
    .table .td p {
      margin: 0;
    }
    .tableBox .table {
      border-collapse: collapse;
    }
  }
}
</style>